export const DISCOVER_PAGE_SIZE = 40

export const DISCOVER_MAX_PAGE = 250
